import React from 'react'
import { Link } from 'react-router-dom'
import logoSB from '../../../../src/assets/img/logo-colores-originales-sin-bajada.png'
import './formErrorMessage.css'

export const FormErrorMessage = ({title, text}) => {
  return (
    <main>
      <article className="a-completed a-completed-height">
        <section className="section-info">

          <div className="logo-login">
                             <img src={logoSB} alt="logo" />
                         </div>
          {/* <h1>{Formulario de Inscripción}</h1> */}
          <h1>{title}</h1>

          {/* <p>Solicitud no encontrada</p> */}
          <p>{text}</p>


          <div className="submit-button smCompleted">
            <Link className="button-send" to={'./login'}>Aceptar</Link>
            {/* <Link type="submit"  className="button-send" value="Aceptar"/> */}

          </div>
        </section>
      </article>



    </main>
  )
}
